import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule, MatInputModule, MatTabsModule, MatFormFieldModule} from '@angular/material';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RestorePasswordComponent } from './restore-password/restore-password.component';

@NgModule({
    declarations: [
        LoginComponent,
        ChangePasswordComponent,
        RestorePasswordComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule
    ],
    exports: [
        LoginComponent
    ],
    entryComponents: [
      ChangePasswordComponent,
      RestorePasswordComponent
    ]
})
export class LoginModule {
}
